<template>
  <div>
    <v-app-bar color="primary" height="40px" elevation="2" app>
      <v-tooltip bottom>
        <template v-slot:activator="{ props }">
          <v-btn
            to="/attendance/list"
            text
            color="transparent"
            size="default"
            v-bind="props"
          >
            <v-icon color="white">mdi-home</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('common.homeScreen') }}</span>
      </v-tooltip>

      <v-spacer />
      <!-- nursery name -->
      <v-menu offset-y transition="slide-y-transition" max-height="80vh">
        <template v-slot:activator="{ props }">
          <v-btn
            class="pr-0"
            dark
            text
            rounded
            size="small"
            v-bind="props"
            :disabled="!currentNurseryName"
          >
            <strong>{{ currentNurseryName }}</strong>
            <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list 
          v-if="me" 
          density="compact" 
          min-height="400" 
          max-height="600"
          class="overflow-y-auto"
        >
          <v-list-item
            v-for="item in me.nurserySchools"
            :key="item.nurseryId"
            link
            @click="setNurseryId(item.nurseryId)"
            :class="item.nurseryId == nurseryId ? 'text-primary font-weight-bold' : ''"
          >
            <v-list-item-title>
              {{ item.nurseryName }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <h5 class="px-4 text-white">|</h5>

      <!-- user -->
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ props }">
          <v-btn
            color="white"
            size="small"
            rounded
            variant="flat"
            v-bind="props"
            :disabled="!username"
          >
            <v-icon color="primary" start>mdi-account-circle</v-icon>
            {{ username }}
          </v-btn>
        </template>
        <v-list density="compact">
          <v-list-item v-if="me" class="pb-2">
            <v-list-item-title class="text-grey">
              {{ me.email }}<br />
              {{ $t('common.loggedInAs') }}
            </v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item to="/logout" link>
            <v-list-item-title>{{ $t('common.logout') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-tooltip bottom>
        <template v-slot:activator="{ props }">
          <v-btn
            to="/logout"
            class="pl-4"
            text
            color="transparent"
            size="default"
            v-bind="props"
          >
            <v-icon color="white">mdi-logout</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('common.logout') }}</span>
      </v-tooltip>
    </v-app-bar>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { meModule } from "@/store/dataModules/meModule";
import { MeNurserySchoolResponse, MeResponse } from "chaild-api/lib";
import LocalDataService from "@/service/LocalDataService";
import { snackbarModule } from "@/store/viewModules/snackbarModule";

export default defineComponent({
  name: "AppBar",

  computed: {
    me: function (): MeResponse | null {
      return meModule.me;
    },
    nurseryId: function (): number | null {
      // return meModule.nurseryId;
      return LocalDataService.getNurseryId();
    },
    currentSchool: function (): MeNurserySchoolResponse | null {
      if (this.me && this.nurseryId) {
        // const currentSchool = this.me.nurserySchools.find((s) => {
        //   return s.isDefault == true;
        // });
        const currentSchool = this.me.nurserySchools.find((s) => {
          return s.nurseryId == this.nurseryId;
        });
        return currentSchool || null;
      } else {
        return null;
      }
    },
    username: function (): string {
      return this.currentSchool
        ? `${this.currentSchool?.lastName || ""} ${
            this.currentSchool?.firstName || ""
          }`
        : "";
    },
    currentNurseryName: function (): string {
      return this.currentSchool ? this.currentSchool.nurseryName : "";
    },
  },

  methods: {
    async setNurseryId(id: number) {
      const response = await meModule
        .putMe({
          defaultNurseryId: id,
        })
        .catch();
      if (response) {
        LocalDataService.setNurseryId(id);
        meModule.setNurseryId(id);

        location.reload();
      } else {
        snackbarModule.snackOn({
          message: this.$t('common.failed'),
          color: "error",
        });
      }
    },
  },
});
</script>
